import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAdminAuth } from "./useAdminAuth";
import { getAdminToken } from "../../../helper/adminAuthStorage";

const LOGO = `${process.env.wordpressApiEndPoint || ""}/wp-content/uploads/2025/07/logo-new.svg`;

const UserIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path d="M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM4 20a8 8 0 0 1 16 0" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
const LockIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <rect x="4.5" y="10.5" width="15" height="10" rx="2" stroke="currentColor" strokeWidth="1.6" />
    <path d="M8 10.5V8a4 4 0 0 1 8 0v2.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);
const EyeIcon = ({ off }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.6" />
    {off ? <path d="M4 20 20 4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" /> : null}
  </svg>
);
const ShieldIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
    <path d="M12 3l7 3v5c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6l7-3Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
const ChevronLeft = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
    <path d="M15 6l-6 6 6 6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const AdminLogin = () => {
  const navigate = useNavigate();
  const {
    step,
    loading,
    error,
    message,
    expiresIn,
    startLogin,
    verifyOtp,
    backToCredentials,
  } = useAdminAuth();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPwd, setShowPwd] = useState(false);
  const [code, setCode] = useState("");
  const [seconds, setSeconds] = useState(0);
  const [logoOk, setLogoOk] = useState(true);

  useEffect(() => {
    if (getAdminToken()) navigate("/admin", { replace: true });
  }, [navigate]);

  useEffect(() => {
    if (step === "otp" && expiresIn) setSeconds(expiresIn);
  }, [step, expiresIn]);

  useEffect(() => {
    if (seconds <= 0) return undefined;
    const t = setInterval(() => setSeconds((s) => (s > 0 ? s - 1 : 0)), 1000);
    return () => clearInterval(t);
  }, [seconds]);

  const fmt = (s) => `${String(Math.floor(s / 60)).padStart(2, "0")}:${String(s % 60).padStart(2, "0")}`;

  const submitCredentials = (e) => {
    e.preventDefault();
    if (!username.trim() || !password) return;
    startLogin(username.trim(), password);
  };
  const submitOtp = async (e) => {
    e.preventDefault();
    if (!code.trim()) return;
    const res = await verifyOtp(code.trim());
    if (res?.ok) navigate("/admin", { replace: true });
  };
  const resend = () => {
    if (username && password) startLogin(username.trim(), password);
  };

  return (
    <div className="adl-root">
      <style>{`
        .adl-root{min-height:100vh;display:flex;align-items:center;justify-content:center;
          background:radial-gradient(1200px 600px at 50% -10%, #eaf0ff 0%, #f5f7fb 55%);
          padding:24px;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Arial,sans-serif;color:#1b2439;}
        .adl-card{width:100%;max-width:410px;background:#fff;border:1px solid #e7ebf3;border-radius:16px;
          box-shadow:0 18px 50px rgba(28,40,74,.10);overflow:hidden;}
        .adl-accent{height:4px;background:linear-gradient(90deg,#283D6B, #3264FF);}
        .adl-body{padding:30px 30px 28px;}
        .adl-logo{display:flex;justify-content:center;margin-bottom:16px;}
        .adl-logo img{height:52px;width:auto;}
        .adl-logo .adl-fallback{font-size:22px;font-weight:800;color:#283D6B;}
        .adl-logo .adl-fallback span{color:#3264FF;}
        .adl-title{text-align:center;font-size:18px;font-weight:700;margin:0 0 4px;}
        .adl-sub{text-align:center;font-size:13px;color:#7a8699;margin:0 0 22px;}
        .adl-label{display:block;font-size:12.5px;font-weight:600;color:#5b6577;margin:0 0 7px;}
        .adl-field{position:relative;margin-bottom:16px;}
        .adl-ic{position:absolute;left:13px;top:50%;transform:translateY(-50%);color:#98a2b6;display:flex;pointer-events:none;}
        .adl-input{width:100%;border:1.5px solid #e2e6ee;border-radius:10px;padding:12px 14px 12px 40px;
          font-size:14px;color:#1b2439;background:#fff;outline:none;transition:border-color .15s, box-shadow .15s;}
        .adl-input::placeholder{color:#aab2c2;}
        .adl-input:focus{border-color:#3264FF;box-shadow:0 0 0 3px rgba(50,100,255,.12);}
        .adl-input:focus + .adl-ic, .adl-field:focus-within .adl-ic{color:#3264FF;}
        .adl-eye{position:absolute;right:10px;top:50%;transform:translateY(-50%);border:none;background:transparent;
          color:#98a2b6;cursor:pointer;display:flex;padding:6px;border-radius:8px;}
        .adl-eye:hover{color:#3264FF;}
        .adl-otp{letter-spacing:10px;text-align:center;font-size:22px;font-weight:700;padding-left:14px;}
        .adl-btn{width:100%;border:none;border-radius:10px;padding:13px 16px;font-size:14.5px;font-weight:700;color:#fff;
          background:linear-gradient(90deg,#2b4fd6,#3264FF);cursor:pointer;display:flex;align-items:center;justify-content:center;gap:9px;
          transition:filter .15s, opacity .15s;}
        .adl-btn:hover{filter:brightness(1.05);}
        .adl-btn:disabled{opacity:.7;cursor:default;}
        .adl-spin{width:15px;height:15px;border:2px solid rgba(255,255,255,.45);border-top-color:#fff;border-radius:50%;animation:adl-sp .7s linear infinite;}
        @keyframes adl-sp{to{transform:rotate(360deg)}}
        .adl-alert{border-radius:9px;padding:10px 13px;font-size:12.8px;margin-bottom:16px;line-height:1.45;}
        .adl-alert.err{background:#fdecee;color:#da102a;}
        .adl-badge{display:flex;flex-direction:column;align-items:center;text-align:center;margin-bottom:18px;color:#3264FF;}
        .adl-badge p{margin:8px 0 0;color:#5b6577;font-size:13px;line-height:1.45;}
        .adl-meta{display:flex;justify-content:space-between;align-items:center;font-size:12.5px;color:#7a8699;margin:14px 2px 18px;}
        .adl-link{border:none;background:transparent;color:#3264FF;font-weight:600;cursor:pointer;font-size:12.5px;padding:0;}
        .adl-link:disabled{opacity:.5;cursor:default;}
        .adl-back{display:flex;align-items:center;justify-content:center;gap:5px;width:100%;border:none;background:transparent;
          color:#7a8699;font-size:13px;margin-top:14px;cursor:pointer;}
        .adl-back:hover{color:#283D6B;}
        .adl-foot{text-align:center;font-size:11.5px;color:#aab2c2;margin-top:20px;}
      `}</style>

      <div className="adl-card">
        <div className="adl-accent" />
        <div className="adl-body">
          <div className="adl-logo">
            {logoOk ? (
              <img src={LOGO} alt="Dahrtours" onError={() => setLogoOk(false)} />
            ) : (
              <div className="adl-fallback">Dahr<span>tours</span></div>
            )}
          </div>

          {step === "credentials" ? (
            <>
              <h1 className="adl-title">Admin Console</h1>
              <p className="adl-sub">Sign in to manage pricing</p>

              {error ? <div className="adl-alert err">{error}</div> : null}

              <form onSubmit={submitCredentials}>
                <label className="adl-label">Username</label>
                <div className="adl-field">
                  <input
                    className="adl-input"
                    type="text"
                    value={username}
                    autoComplete="username"
                    onChange={(e) => setUsername(e.target.value)}
                    placeholder="Enter your username"
                  />
                  <span className="adl-ic"><UserIcon /></span>
                </div>

                <label className="adl-label">Password</label>
                <div className="adl-field">
                  <input
                    className="adl-input"
                    type={showPwd ? "text" : "password"}
                    value={password}
                    autoComplete="current-password"
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Enter your password"
                    style={{ paddingRight: 42 }}
                  />
                  <span className="adl-ic"><LockIcon /></span>
                  <button
                    type="button"
                    className="adl-eye"
                    onClick={() => setShowPwd((v) => !v)}
                    aria-label={showPwd ? "Hide password" : "Show password"}
                  >
                    <EyeIcon off={showPwd} />
                  </button>
                </div>

                <button type="submit" className="adl-btn" disabled={loading} style={{ marginTop: 4 }}>
                  {loading ? <span className="adl-spin" /> : null}
                  {loading ? "Sending code…" : "Continue"}
                </button>
              </form>
            </>
          ) : (
            <>
              <div className="adl-badge">
                <ShieldIcon />
                <p>{message || "Enter the verification code sent to your email."}</p>
              </div>

              {error ? <div className="adl-alert err">{error}</div> : null}

              <form onSubmit={submitOtp}>
                <label className="adl-label">Verification code</label>
                <div className="adl-field">
                  <input
                    className="adl-input adl-otp"
                    type="text"
                    inputMode="numeric"
                    value={code}
                    autoFocus
                    maxLength={8}
                    onChange={(e) => setCode(e.target.value.replace(/[^0-9]/g, ""))}
                    placeholder="••••••"
                  />
                </div>

                <div className="adl-meta">
                  <span>{seconds > 0 ? `Expires in ${fmt(seconds)}` : "Code expired"}</span>
                  <button type="button" className="adl-link" onClick={resend} disabled={loading}>
                    Resend code
                  </button>
                </div>

                <button type="submit" className="adl-btn" disabled={loading}>
                  {loading ? <span className="adl-spin" /> : null}
                  {loading ? "Verifying…" : "Verify & sign in"}
                </button>

                <button type="button" className="adl-back" onClick={backToCredentials}>
                  <ChevronLeft /> Back
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
